<svelte:head>
	<title>buttpineapples</title>
	<script type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js"></script>
</svelte:head>

<script>
	import * as Tone from 'tone'

	let visible = false;

	const sampler = new Tone.Sampler({
		urls: {
			A0: "george costanza 2.wav",
			A5: "george costanza.wav",
			A2: "Joker.wav",
			A3: "Lightning McQueen.wav",
			A4: "scott the woz.wav",
			A1: "Dio.wav",
		},
		baseUrl: "assets/"
	}).toDestination();

	function triggerSample() {
		Tone.start();

		const samples = ["A0","A1","A2","A3","A4","A5"];

		const randomIndex = Math.floor(Math.random() * samples.length);

		sampler.triggerAttack(samples[randomIndex]);
	}
</script>

<main>
	<model-viewer src="assets/Pineapple.glb"
	alt="Pineapple 3D Model"
	camera-controls
	disable-zoom
	auto-rotate
	class:visible	
	on:model-visibility={() => visible = true}
	
	on:pointerdown={triggerSample}>
		<div slot="progress-bar"></div>
		<div slot="poster"></div>
	</model-viewer>
</main>



<style>	
	:global(body) {
		background-color: #3b6657;
		background-image: url("data:image/svg+xml,%3Csvg width='208' height='104' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23663134' fill-opacity='1'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
		
		overscroll-behavior: contain;
		overscroll-behavior-y: contain;
	}
	main {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	model-viewer {
		height: 70%;
		width: 40vmax;
		margin-bottom: 7%;
		transform: scale(0);		
		transition: transform 1.5s;
	}

	model-viewer.visible {
		transform: scale(1);
	}
</style>